import { Link, useNavigate, useLocation } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const go = (href) => {
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => document.querySelector(href)?.scrollIntoView({ behavior: "smooth" }), 150);
      return;
    }
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  };
  return (
    <footer className="relative z-[2] bg-[#050505] border-t border-white/10 py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5 mb-5">
              <img
                src="/agentica-mark.png"
                alt="Agentica AI Solutions logo"
                className="h-14 w-auto"
              />
              <span className="font-display text-lg font-700 tracking-tight text-white">
                Agentica<span className="bg-gradient-to-r from-[#4f6bff] to-[#9d6bff] bg-clip-text text-transparent"> AI</span>
              </span>
            </div>
            <p className="text-white/50 max-w-sm leading-relaxed text-sm">
              Consulting, engineering, and products for the agentic era. We help teams build
              autonomous AI that actually ships.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="overline text-white/40 mb-4">Navigate</p>
            <div className="flex flex-col gap-3">
              {[["Services", "#services"], ["Products", "#products"], ["Work", "#work"], ["Approach", "#approach"], ["About", "#about"]].map(([l, h]) => (
                <button key={h} onClick={() => go(h)} className="text-left text-white/60 hover:text-white transition-colors duration-300 text-sm" data-testid={`footer-link-${l.toLowerCase()}`}>
                  {l}
                </button>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <p className="overline text-white/40 mb-4">Get in touch</p>
            <a href="mailto:ikumar@agentica-sol.com" className="block text-white/60 hover:text-white transition-colors duration-300 text-sm mb-2">ikumar@agentica-sol.com</a>
            <a href="tel:+17542182448" className="block text-white/60 hover:text-white transition-colors duration-300 text-sm mb-2">+1 754 218 2448</a>
            <p className="text-white/60 text-sm mb-4">Fort Lauderdale, Florida, United States</p>
            <button onClick={() => go("#contact")} className="inline-flex items-center gap-1.5 rounded-full border border-white/15 text-white px-5 py-2.5 text-sm hover:bg-white hover:text-void transition-colors duration-300" data-testid="footer-cta">
              Book a call
            </button>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-white/35 text-xs">© {new Date().getFullYear()} Agentica AI Solutions. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <Link to="/privacy" className="text-white/35 hover:text-white text-xs transition-colors duration-300" data-testid="footer-privacy-link">Privacy Policy</Link>
            <Link to="/terms" className="text-white/35 hover:text-white text-xs transition-colors duration-300" data-testid="footer-terms-link">Terms &amp; Conditions</Link>
          </div>
          <p className="text-white/35 text-xs">Built for the autonomous enterprise.</p>
        </div>
      </div>
    </footer>
  );
}
